import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        mainContentContainer: {
            w: '100%',
            h: 'auto',
            flexDir: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingX: {
                base: 'small.base',
                sm: 'small.base',
                md: 'small.base',
                lg: remCalc(100),
                xl: remCalc(250),
            },
        },
        breadcrumbContainer: {
            w: '100%',
            paddingX: {
                base: 'small.base',
                sm: 'small.base',
                md: 'small.base',
                lg: remCalc(100),
                xl: remCalc(250),
            },
            h: 'auto',
            paddingTop: 'small.base',
        },
        herobannerContainer: {
            flexDir: 'column',
            w: '100%',
            h: remCalc(255),
            justifyContent: 'space-evenly',
            alignItems: 'center',
            bg: 'background.light',
        },
        herobannerCategoryText: {
            paddingX: {
                base: 'small.base',
                sm: 'small.base',
                md: 'small.base',
                lg: remCalc(100),
                xl: remCalc(250),
            },
        },
        headerContainer: {
            w: '100%',
            h: remCalc(40),
            marginTop: 'medium.lg',
            marginBottom: 'medium.base',

            justifyContent: 'space-between',
        },
        filterMenuContainer: {
            w: '100%',
            align: 'center',
            // display: {
            //     base: 'none',
            //     lg: 'block',
            // },
        },
        gridConfig: {
            w: '100%',
            columnGap: 'medium.base',
            rowGap: {
                base: 'xsmall.base',
                lg: 'large.lg',
            },
            marginTop: {
                base: 'medium.base',
                sm: 'medium.base',
                md: 'xlarge.base',
                lg: 'xlarge.base',
            },
        },
        showMoreSectionContainer: {
            flexDir: 'column',
            gap: 'small.lg',
            paddingBottom: remCalc(160),
            justifyContent: 'center',
            maxW: remCalc(450),
            marginTop: {
                base: 'xxsmall.base',
                lg: 'large.lg',
            },
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            gap: remCalc(3),
        },
        filterMenuInnerContainer: {
            w: '100%',
            h: 'auto',
            //h: 'auto',
            gap: {
                base: 'small.base',
                lg: 'small.lg',
            },
            flexWrap: 'nowrap',
            overflowX: 'hidden',
        },
    },
}
